module.exports = __webpack_public_path__ + "img/thumb_document_pdf.6a4738df.svg";